import cn from 'classnames';
import { useMemo, useState } from 'react';

import { CategoryDetail } from '@api/catalog';

import CategoryPanel from '@components/CategoryPanel';

import { useMatchMedia } from '@scripts/hooks';

import ChevronDownIcon from '@icons/24/chevron-down.svg';

import styles from './SubCategory.module.scss';

const MOBILE_CATEGORIES_LIMIT = 4;
const TABLET_CATEGORIES_LIMIT = 6;

const CategoryCategoriesList = ({ categories }: { categories: CategoryDetail[] }) => {
    const [isExpanded, setIsExpanded] = useState(false);

    const isMobile = useMatchMedia({ maxWidth: 767 }, false);
    const isTablet = useMatchMedia({ minWidth: 768, maxWidth: 1023 }, false);

    const { visibleCategories, isCollapsible } = useMemo(() => {
        if (isMobile) {
            return {
                visibleCategories: isExpanded ? categories : categories.slice(0, MOBILE_CATEGORIES_LIMIT),
                isCollapsible: categories.length > MOBILE_CATEGORIES_LIMIT,
            };
        }

        if (isTablet) {
            return {
                visibleCategories: isExpanded ? categories : categories.slice(0, TABLET_CATEGORIES_LIMIT),
                isCollapsible: categories.length > TABLET_CATEGORIES_LIMIT,
            };
        }

        return {
            visibleCategories: categories,
            isCollapsible: false,
        };
    }, [categories, isExpanded, isMobile, isTablet]);

    return (
        <div className={styles.categoriesSection}>
            <div className={styles.categoriesGrid}>
                {visibleCategories.map(panel => (
                    <CategoryPanel
                        key={panel.id}
                        link={`/catalog/${panel.code}`}
                        image={panel.image}
                        name={panel.name}
                        code={panel.code}
                    />
                ))}
            </div>

            {isCollapsible && (
                <button
                    type="button"
                    className={styles.categoriesToggle}
                    onClick={() => setIsExpanded(prev => !prev)}
                    aria-expanded={isExpanded}
                >
                    <span className={styles.categoriesToggleContent}>
                        <span className={styles.categoriesToggleLabel}>
                            {isExpanded ? 'Свернуть' : 'Все подкатегории'}
                        </span>
                        <ChevronDownIcon
                            className={cn(
                                styles.categoriesToggleIcon,
                                isExpanded && styles.categoriesToggleIcon_expanded
                            )}
                        />
                    </span>
                </button>
            )}
        </div>
    );
};

export default CategoryCategoriesList;
